import { Button, ButtonProps } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { usePermission } from '../../lib/usePermission';
import { PermissionRequirement } from '../../lib/permissions';

type SttButtonNewProps = {
    caption?: string;
    onClick: () => void;
    /** Permiso v8 que hace falta para ver el botón. Sin él, se ve siempre. */
    permission?: PermissionRequirement;
} & ButtonProps;

/**
 * Add button
 */
export function SttButtonNew({
    caption,
    onClick,
    permission,
    ...rest
}: SttButtonNewProps) {
    const { t } = useTranslation();
    const { can } = usePermission();

    if (permission && !can(permission)) return null;

    return (
        <Button
            variant="contained"
            onClick={onClick}
            startIcon={<AddIcon />}
            color="primary"
            {...rest}
        >
            {caption || t('Add')}
        </Button>
    );
}
